import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=5b2a0ae8"
import script from "./fee.vue?vue&type=script&lang=js"
export * from "./fee.vue?vue&type=script&lang=js"
import style0 from "./fee.vue?vue&type=style&index=0&id=5b2a0ae8&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports